import {
  Null,
  Array as RArray,
  Boolean as RBoolean,
  Null as RNull,
  Number as RNumber,
  Optional as ROptional,
  Record as RRecord,
  String as RString,
  Union as RUnion,
  Static,
} from "runtypes";

import { DisplayTableColumnId, DisplayTableConfigId } from "../idTypeBrands.js";

import { ColumnAggregationsDefinition } from "./aggregationTypes.js";
import { CalcsDefinition } from "./calcTypes.js";
import { ColumnDisplayFormat } from "./columnDisplayFormatTypes.js";
import { ConditionalFormattingDefinition } from "./conditionalFormattingTypes.js";
import { TableFiltersDefinition } from "./filterTypes.js";
import { SortDirectionLiteral } from "./outputTypes.js";
import { CellReferencesV2 } from "../code/cellReferencesV2.js";
import { CellReferencesParseError } from "../code/cellReferencesV1.js";

export const ColumnPropertyPayload = RRecord({
  originalName: DisplayTableColumnId,
  displayFormat: ROptional(ColumnDisplayFormat),
  renameTo: ROptional(RString),
  size: ROptional(RNumber),
  revision: RNumber,
  wrapText: ROptional(RBoolean),
});

export const DisplayTableConfigPayload = RRecord({
  id: DisplayTableConfigId,
  revision: RNumber,
  pageSize: RNumber,
  height: ROptional(RNumber),
  hideIcons: RBoolean,
  defaultColumnWidth: ROptional(RUnion(RNumber, RNull)),
  hideIndex: RBoolean,
  sortByColumnDefault: ROptional(RString),
  sortByIndexColumnDefault: ROptional(RNumber),
  sortDirectionDefault: SortDirectionLiteral,
  calcs: ROptional(CalcsDefinition),
  conditionalFormatting: ROptional(ConditionalFormattingDefinition),
  filters: ROptional(TableFiltersDefinition),
  columnProperties: RArray(ColumnPropertyPayload).asReadonly(),
  customColumnOrdering: ROptional(RArray(DisplayTableColumnId).asReadonly()),
  pivotColumnOrdering: ROptional(
    RArray(RUnion(SortDirectionLiteral, RNull)).asReadonly(),
  ),
  pinnedColumns: ROptional(RArray(RString).asReadonly()),
  hiddenColumns: ROptional(RArray(RString).asReadonly()),
  pinIndexColumns: RBoolean,
  showAggregations: ROptional(RBoolean),
  columnAggregations: ROptional(ColumnAggregationsDefinition),
  conditionalFormattingReferences: ROptional(RUnion(CellReferencesV2, Null)),
  conditionalFormattingReferencesParseError: ROptional(
    RUnion(CellReferencesParseError, Null),
  ),
  filtersReferences: ROptional(RUnion(CellReferencesV2, Null)),
  filtersReferencesParseError: ROptional(
    RUnion(CellReferencesParseError, Null),
  ),
});

export type DisplayTableConfigPayload = Static<
  typeof DisplayTableConfigPayload
>;
